<header>{{'MOVEDLG.SHARED_FOLDERS_WARNING.HEADER' | translate}}</header>
<section>
  @for (message of messages; track message) {
    <span>{{message.text | translate:message}}. </span>
  }
</section>

<footer class="fr-float-left">
  <button class="cb-btn fa-pull-right" mat-dialog-close>{{'OPENSAVEDLG.CANCEL' | translate}}</button>
  <button class="cb-btn fa-pull-right" (click)="closeDlg(true)">{{'OPENSAVEDLG.MOVE' | translate}}</button>
</footer>

